import {combineReducers} from 'redux';

import dashboardState from './dashboard.reducer';
import clientState from '../client/shared/client.reducer';

export default combineReducers({
  dashboard: dashboardState,
  clients: clientState
});
